import { render, staticRenderFns } from "./GraphicalForm.vue?vue&type=template&id=287e4c50&scoped=true&"
import script from "./GraphicalForm.vue?vue&type=script&lang=js&"
export * from "./GraphicalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e4c50",
  null
  
)

export default component.exports